import React from "react";
import Paper from "@material-ui/core/Paper";
import Skeleton from "@material-ui/lab/Skeleton";
import useStyles from "./styles";

/**
 * CourseSkeleton — placeholder card shown while course search results load.
 * Mirrors the layout of the Course card so content doesn't jump when data arrives.
 */
const CourseSkeleton = () => {
  const classes = useStyles();

  return (
    <Paper className={classes.courseCard} elevation={0}>
      <div className={classes.courseCardBody}>
        <div className={classes.courseCardInfo}>
          <Skeleton variant="text" width="55%" height={30} />
          <Skeleton variant="text" width="70%" height={20} />
          <div className={classes.courseCardChips}>
            <Skeleton variant="rect" width={70} height={24} style={{ borderRadius: 12 }} />
            <Skeleton variant="rect" width={85} height={24} style={{ borderRadius: 12 }} />
          </div>
        </div>
        <div className={classes.courseCardActions}>
          <Skeleton variant="rect" width={64} height={30} style={{ borderRadius: 4 }} />
          <Skeleton variant="rect" width={64} height={30} style={{ borderRadius: 4 }} />
        </div>
      </div>
    </Paper>
  );
};

/**
 * CourseListSkeleton — renders a stack of course card skeletons.
 */
export const CourseListSkeleton = ({ count = 5 }) => (
  <>
    {Array.from({ length: count }, (_, i) => (
      <CourseSkeleton key={i} />
    ))}
  </>
);

export default CourseSkeleton;
